import React from "react";
import Navbar from "../common/Navbar";
import "../../styles/contactUs.css";

const TITLE = "YOUR NEXT BIG IDEA SHOULD NOT STAY IN YOUR NOTES APP.";

const ContactHero = () => {
  return (
    <div className="cu">
      <Navbar />

      <section className="cu-hero">
        <span className="cu-hero-watermark" aria-hidden="true">
          Contact
        </span>
        <div className="cu-glow cu-glow--red" />
        <div className="cu-glow cu-glow--navy" />

        <div className="container position-relative z-1 text-center">
          <p className="cu-eyebrow">
            <span className="cu-eyebrow-dot" />
            Contact HKI Media
          </p>

          <h1 className="cu-title">
            {TITLE.split(" ").map((word, i) => (
              <span
                key={word + i}
                className={`cu-title-word ${
                  i === 2 || i === 3 ? "section-heading-accent" : ""
                }`}
                style={{ animationDelay: `${i * 0.1 + 0.1}s` }}
              >
                {word}&nbsp;
              </span>
            ))}
          </h1>

          <p className="cu-subtitle">
           Whatever your brand needs next, there is a good chance we already have the people, ideas and caffeine required to make it happen.
          </p>
          <p className="cu-subtitle"> Let’s Connect</p>
        </div>
      </section>
    </div>
  );
};

export default ContactHero;
